import type { IconType } from '@graftcode/design-system'
import { Icon } from '@graftcode/design-system'

import type { FeedbackMoodValue } from '../../consts/feedback-mood-values.const'

export type FeedbackMoodOption = {
  value: FeedbackMoodValue
  icon: IconType
  labelKey: string
}

export const FEEDBACK_MOOD_OPTIONS: FeedbackMoodOption[] = [
  { value: 0, icon: Icon.EmojiAngryRegular, labelKey: 'moods.angry' },
  { value: 1, icon: Icon.EmojiSadRegular, labelKey: 'moods.sad' },
  { value: 2, icon: Icon.EmojiMehRegular, labelKey: 'moods.meh' },
  { value: 3, icon: Icon.EmojiRegular, labelKey: 'moods.happy' },
  { value: 4, icon: Icon.DSEmojiCustom, labelKey: 'moods.excited' },
]
